/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import armLogo from '@/assets/spray-gun.png'

function PaintNode({ data, isConnectable }) {
  return (
    <div className="custom-node-generic robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={armLogo} alt="Pain Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Painting</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
      <Handle type="target" position={Position.Right} />
    </div>
  )
}

export default PaintNode
